module.exports = __webpack_public_path__ + "static/img/07.aef9077.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/02/07.jpg
// module id = Q+k1
// module chunks = 0